import { render, staticRenderFns } from "./AddressTagsUploadedModal.vue?vue&type=template&id=bb285c82&"
import script from "./AddressTagsUploadedModal.vue?vue&type=script&lang=js&"
export * from "./AddressTagsUploadedModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports